import PosMenuTop from "@/Components/PosMenu/PosMenuTop";
import Spinner from "@/Components/Spinner/Spinner";
import { editOrderAtom } from "@/shared/atoms";
import { useSearchText } from "@/shared/atoms/usePosOrderSearchAtom";
import useCouriersHook from "@/shared/hooks/useCouriersHook";
import { posSources } from "@/shared/utils/constant";
import { filterOrdersBySearch } from "@/shared/utils/helpers";
import useOrdersQuery from "@/shared/v2/queries/useOrdersQuery";
import { useSetAtom } from "jotai";
import { useEffect, useMemo, useState } from "react";
import PosMethods from "./PosMethods";
import { useSetPosShowOrders } from "@/shared/atoms/usePosShowOrders";
import OrderCard from "@/Components/Order/OrderCard";

const PosOrders = ({ children }) => {
  const setEditOrder = useSetAtom(editOrderAtom);
  const { data, isPending } = useOrdersQuery();
  const [source, setSource] = useState<number[]>([]);
  const couriers = useCouriersHook();
  const text = useSearchText();
  const setShowOrders = useSetPosShowOrders();
  const filteredOrders = useMemo(() => {
    const orders = filterOrdersBySearch(data.flat(2), text, couriers);
    const reversedFilteredOrders = [...orders].reverse();
    return reversedFilteredOrders;
  }, [data, text, couriers]);

  const ordersSources = useMemo(() => {
    return posSources.filter((source) => {
      return source.value.some((value) =>
        filteredOrders.find((order) => order.order_information.source === value)
      );
    });
  }, [filteredOrders]);

  const orders = useMemo(() => {
    return filteredOrders.filter((order) =>
      source.includes(-1)
        ? true
        : source.includes(order.order_information.source)
    );
  }, [filteredOrders, source]);

  useEffect(() => {
    if (source.length === 0) {
      if (ordersSources.length === 1) {
        setSource(ordersSources[0].value);
      } else {
        setSource([-1]);
      }
    }
  }, [ordersSources, source]);
  return (
    <div className="overflow-x-hidden">
      <PosMenuTop />
      {!isPending && ordersSources.length > 1 && (
        <PosMethods
          setSource={setSource}
          active={source}
          methods={ordersSources}
        />
      )}
      {isPending ? (
        <Spinner size="1rem" />
      ) : (
        <div className="flex flex-wrap gap-4 overflow-hidden mt-4">
          {orders?.map((order) => (
            <div
              key={order.order_information.item_id}
              className="flex-[1_1_30%]"
            >
              <OrderCard
                onClick={() => {
                  setEditOrder(order);
                  setShowOrders(false);
                }}
                showOrderCount={true}
                showTipsOnLive={false}
                order={order}
                actionButtonType="print"
              />
            </div>
          ))}
        </div>
      )}
      {children}
    </div>
  );
};

export default PosOrders;
